import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { S } from '../utils/styles';

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ company_name:'', country:'', currency:'USD', payment_terms:'', shipping_terms:'', contact_name:'', email:'', phone:'' });
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  const load = () => api.get('/customers').then(r => setCustomers(r.data)).catch(()=>{});

  const filtered = customers.filter(c =>
    c.company_name.toLowerCase().includes(search.toLowerCase()) ||
    (c.country||'').toLowerCase().includes(search.toLowerCase())
  );

  const save = async () => {
    if (!form.company_name) return alert('Company name required');
    setSaving(true);
    try { await api.post('/customers', form); load(); setShowAdd(false); }
    catch(e) { alert(e.response?.data?.error || 'Error saving customer'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h1 style={{ fontSize:22, fontWeight:600, margin:0 }}>Customers</h1>
        <button onClick={() => setShowAdd(true)} style={S.btnPrimary}>+ Add customer</button>
      </div>
      <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search customers..." style={{ ...S.input, width:280, marginBottom:16 }} />

      <div style={{ background:'#fff', borderRadius:10, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead><tr>
            {['Company','Country','Currency','Active orders','Active value','Orders shipped','Shipped value',''].map(h => <th key={h} style={S.th}>{h}</th>)}
          </tr></thead>
          <tbody>
            {filtered.map(c => (
              <tr key={c.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                <td style={{ ...S.td, fontWeight:600 }}>{c.company_name}</td>
                <td style={{ ...S.td, color:'#6b7280' }}>{c.country}</td>
                <td style={S.td}>{c.currency}</td>
                <td style={{ ...S.td, fontWeight:500 }}>{c.active_orders||0}</td>
                <td style={{ ...S.td, color:'#3b82f6', fontWeight:500 }}>
                  {c.active_value > 0 ? `$${(c.active_value||0).toLocaleString(undefined,{maximumFractionDigits:0})}` : '—'}
                </td>
                <td style={{ ...S.td, color:'#6b7280' }}>{c.closed_orders||0}</td>
                <td style={{ ...S.td, color:'#10b981', fontWeight:500 }}>
                  {c.shipped_value > 0 ? `$${(c.shipped_value||0).toLocaleString(undefined,{maximumFractionDigits:0})}` : '—'}
                </td>
                <td style={S.td}><Link to={`/customers/${c.id}`} style={{ color:'#3b82f6', fontSize:12, textDecoration:'none' }}>View →</Link></td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={8} style={{ textAlign:'center', padding:32, color:'#9ca3af' }}>No customers yet</td></tr>}
          </tbody>
        </table>
      </div>

      {showAdd && (
        <div style={S.overlay}>
          <div style={{ ...S.modal, width:520 }}>
            <div style={{ fontSize:16, fontWeight:600, marginBottom:20 }}>Add customer</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:14 }}>
              {[['company_name','Company name *'],['country','Country *'],['contact_name','Contact name'],['email','Email'],['phone','Phone'],['payment_terms','Payment terms'],['shipping_terms','Shipping terms']].map(([k,l]) => (
                <div key={k}>
                  <label style={S.label}>{l}</label>
                  <input value={form[k]} onChange={e => setForm(p=>({...p,[k]:e.target.value}))} style={S.input} />
                </div>
              ))}
              <div>
                <label style={S.label}>Region</label>
                <select value={form.region} onChange={e => setForm(p=>({...p,region:e.target.value}))} style={S.input}>
                  {['UK', 'Europe', 'Russia', 'Middle East', 'Gaza Patch', 'Australia', 'USA', 'Latin America', 'South Korea', 'Japan', 'South East Asia', 'South Africa', 'Africa', 'Other'].map(r => <option key={r}>{r}</option>)}
                </select>
              </div>
              <div>
                <label style={S.label}>Currency</label>
                <select value={form.currency} onChange={e => setForm(p=>({...p,currency:e.target.value}))} style={S.input}>
                  {['USD','EUR','GBP','AED','AUD'].map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display:'flex', gap:10, paddingTop:14, borderTop:'1px solid #e5e7eb' }}>
              <button onClick={save} disabled={saving||!form.company_name} style={S.btnPrimary}>{saving?'Saving...':'Save customer'}</button>
              <button onClick={() => setShowAdd(false)} style={S.btnSecondary}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
